/**
 * Resets the inventory form fields.
 * @param {Function} setItemName
 * @param {Function} setPricePerUnit
 * @param {Function} setQuantity
 * @param {Function} setEditingKey
 * @param {Function} setErrorMessage
 */
export const resetInventoryForm = (
  setItemName,
  setPricePerUnit,
  setQuantity,
  setEditingKey,
  setErrorMessage
) => {

  setItemName("");
  setPricePerUnit("");
  setQuantity("");
  setEditingKey(null);
  setErrorMessage("");
};